import { render, staticRenderFns } from "./AffectTypeEdit.vue?vue&type=template&id=65ee11f9"
import script from "./AffectTypeEdit.vue?vue&type=script&lang=js"
export * from "./AffectTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports